import React, { Component } from 'react';
import $ from 'jquery';
import { connect } from 'react-redux';
import mapStateToProps from '../../../store/mapStateToProps';
import mapDispatchToProps from '../../../store/mapDispatchToProps';
import { hit } from '../../metrics';
import HelmetSite from '../HelmetSite';
import CaseFooterNew from '../CaseFooterNew';
import './style.css';

const base = '/cases/img/opus';
const textFrames = new Set(['03', '05', '06', '07', '08', '09', '11', '12']);
const frameImage = name => `${base}/${name}.${textFrames.has(name) ? 'webp' : 'png'}`;

const introCopy = [
  'Для клубного дома «Опус» на Павелецкой набережной мы обновили бренд-платформу — и вместе с ней пересобрали сайт: он должен был стать первым касанием с брендом, говорить на языке его философии и при этом оставаться ясной, удобной точкой входа для будущего резидента.'
];

const copySections = {
  concept: {
    title: 'Концепция',
    text: 'В основе сайта — идея slow living. Пользователи медленно перемещаются по пространству проекта, будто по самому дому: ритм скролла намеренно замедлен, между смысловыми блоками — большие паузы, а переходы построены на плавности движений.'
  },
  design: {
    title: 'Дизайн',
    text: 'Визуальный язык сайта напрямую передаёт характер проекта: тёплая нейтральная палитра, крупная типографика, много воздуха между блоками. Фактуры дерева, камня и текстиля, которые формируют интерьеры проекта, стали частью цифровой среды — в текстурах, свете и переходах между экранами.'
  },
  philosophy: {
    title: 'Философия, которую можно прожить',
    text: 'Обновлённый сайт работает как продолжение бренд-платформы: он не просто презентует «Опус», а даёт прожить его атмосферу — спокойствие, природу и внимание к деталям — ещё до личного визита.'
  }
};

const CopySection = ({ title, text }) => (
  <section className="opus-copy opus-gap">
    <h2>{title}</h2>
    <p>{text}</p>
  </section>
);

const mobileCopy = [
  'Мобильная версия сайта полностью повторяет функционал основной версии, обеспечивая пользователям доступ ко всем необходимым функциям в любое время и в любом месте.',
  'Интерфейс оптимизирован для удобства использования на мобильных устройствах, что делает навигацию простой и интуитивной. При этом визуальный дизайн сохраняет эстетическую привлекательность, отражая фирменный стиль проекта и создавая гармоничное восприятие даже на небольших экранах.'
];

const sections = [
  { name: 'concept', copy: copySections.concept },
  { name: '03', ratio: '1921 / 1068.75', mobile: 'split', video: true },
  { name: '04', ratio: '1921 / 1080', mobile: 'full' },
  { name: 'design', copy: copySections.design },
  { name: '05', ratio: '1920 / 1080', mobile: 'split', video: true },
  { name: '06', ratio: '1921 / 1269.958', mobile: 'split' },
  { name: 'philosophy', copy: copySections.philosophy },
  { name: '07', ratio: '1920 / 1080', mobile: 'full' },
  { name: '08', showcase: true },
  { name: '09', ratio: '1920 / 534.375', mobile: 'split' },
  { name: '10', ratio: '1921 / 1080', mobile: 'full' },
  { name: '11', liveMobile: true },
  { name: '12', ratio: '1921 / 1186', mobile: 'hidden', video: true }
];

const FrameMedia = ({ name, video, setVideoRef, className }) => video ? (
  <video ref={setVideoRef} className={className} muted loop playsInline preload="metadata" poster={frameImage(name)}>
    <source src={`${base}/${name}.mp4`} type="video/mp4" />
  </video>
) : <img className={className} src={frameImage(name)} alt="" loading="lazy" />;

const Frame = ({ name, ratio, mobile, mobileAsset, video, setVideoRef, isMobile }) => {
  if (isMobile && mobile === 'hidden') return null;
  return (
    <section className={`opus-frame opus-frame--${name}`} style={{ '--opus-ratio': ratio }}>
      {isMobile ? (
        <div className={`opus-frame__mobile opus-frame__mobile--${mobile}`}>
          {mobile === 'split'
            ? ['left', 'right'].map(side => <img src={`${base}/${name}-${side}.webp`} alt="" loading="lazy" key={side} />)
            : <img src={mobileAsset ? `${base}/${mobileAsset}.webp` : frameImage(name)} alt="" loading="lazy" />}
        </div>
      ) : <FrameMedia name={name} video={video} setVideoRef={setVideoRef} className="opus-frame__desktop" />}
    </section>
  );
};

const MobileSite = ({ setVideoRef }) => (
  <section className="opus-site opus-gap">
    <div className="opus-site__visual">
      <video ref={setVideoRef} className="opus-site__desktop" muted loop playsInline preload="metadata" poster={`${base}/11.webp`}>
        <source src={`${base}/11.mp4`} type="video/mp4" />
      </video>
      <img className="opus-site__mobile" src={`${base}/mobile-01.webp`} alt="Мобильная версия сайта Опус" loading="lazy" />
    </div>
    <div className="opus-site__copy">
      {mobileCopy.map(paragraph => <p key={paragraph}>{paragraph}</p>)}
    </div>
  </section>
);

class VideoShowcase extends Component {
  state = { started: false };

  setVideo = node => { this.video = node; };

  play = event => {
    if (event) event.stopPropagation();
    if (!this.video) return;
    const playback = this.video.play();
    if (playback && playback.then) {
      playback.then(() => this.setState({ started: true })).catch(() => {});
    } else {
      this.setState({ started: true });
    }
  };

  playFromContainer = () => {
    if (!this.state.started && window.matchMedia('(max-width: 1000px)').matches) this.play();
  };

  render() {
    return (
      <section className="opus-video-showcase opus-gap" onClick={this.playFromContainer}>
        <div className="opus-video-showcase__background" aria-hidden="true" />
        <div className="opus-video-showcase__player">
          {!this.state.started && <img className="opus-video-showcase__poster" src={`${base}/08-video.webp`} alt="Интерфейс сайта Опус" />}
          <video
            ref={this.setVideo}
            className={this.state.started ? 'is-started' : ''}
            playsInline
            preload="metadata"
            controls={this.state.started}
            onEnded={() => this.setState({ started: false })}
          >
            <source src={`${base}/showcase-video.mp4`} type="video/mp4" />
          </video>
          {!this.state.started && (
            <button className="opus-video-showcase__play" type="button" onClick={this.play} aria-label="Воспроизвести видео Опус">
              <img src="/cases/img/highlife/play.svg" alt="" />
            </button>
          )}
        </div>
      </section>
    );
  }
}

class Opus extends Component {
  state = { mobile: window.innerWidth <= 1000 };

  resize = () => this.setState({ mobile: window.innerWidth <= 1000 });

  videos = [];

  setVideoRef = node => {
    if (node && !this.videos.includes(node)) {
      this.videos.push(node);
      if (this.videoObserver) this.videoObserver.observe(node);
    }
  };

  componentDidMount() {
    window.addEventListener('resize', this.resize);
    this.props.setProjectName('opus');
    $('body').addClass('case-expanded hash-opus');
    this.props.changeCase(null);
    window.scrollTo(0, 0);
    hit(window.location.pathname);

    if (this.videos.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.videoObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const play = entry.target.play();
            if (play && play.catch) play.catch(() => {});
          } else {
            entry.target.pause();
          }
        });
      }, { threshold: 0.08 });
      this.videos.forEach(video => this.videoObserver.observe(video));
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
    $('body').removeClass('hash-opus');
    if (this.videoObserver) this.videoObserver.disconnect();
  }

  render() {
    return (
      <div className="case">
        <div className="case-content" id="case-opus">
          <h1 className="opus-visually-hidden">Жилой комплекс «Опус»</h1>

          <section className="opus-cover">
            <div className="opus-cover__visual">
              <div className="opus-cover__background" aria-hidden="true" />
              <div className="opus-cover__building-mask">
                <div className="opus-cover__building-canvas">
                  <img src={`${base}/cover-building.png`} alt="Жилой комплекс Опус" loading="eager" />
                  <span aria-hidden="true" />
                </div>
              </div>
              <img className="opus-cover__logo" src={`${base}/cover-logo.svg`} alt="Опус" />
            </div>
            <div className="opus-cover__intro">
              <div>
                <h2>Жилой комплекс «Опус»</h2>
                <dl>
                  <div><dt>Клиент</dt><dd>Pioneer</dd></div>
                  <div><dt>Виды работ</dt><dd>Платформа бренда&nbsp;&nbsp;&nbsp;Сайт</dd></div>
                </dl>
              </div>
              <div className="opus-cover__copy">
                {introCopy.map(paragraph => <p key={paragraph}>{paragraph}</p>)}
              </div>
            </div>
          </section>

          <section className="opus-parallax opus-gap">
            <video ref={this.setVideoRef} muted loop playsInline preload="metadata" poster={`${base}/02.webp`}>
              <source src={`${base}/02-clean.mp4`} type="video/mp4" />
            </video>
          </section>

          {sections.map(section => {
            if (section.copy) return <CopySection key={section.name} {...section.copy} />;
            if (section.showcase) return <VideoShowcase key={section.name} />;
            if (section.liveMobile) return <MobileSite key={section.name} setVideoRef={this.setVideoRef} />;
            return <Frame isMobile={this.state.mobile} key={section.name} setVideoRef={this.setVideoRef} {...section} />;
          })}

          {this.state.mobile && <section className="opus-mobile-showcase opus-gap" aria-label="Мобильные страницы сайта Опус">
            {[
              ['02', 'Подбор квартир'],
              ['03', 'О проекте'],
              ['04', 'Фасады и террасы'],
              ['01', 'Расположение']
            ].map(([name, alt]) => (
              <img src={`${base}/mobile-aligned-${name}.png`} alt={alt} loading="lazy" key={name} />
            ))}
          </section>}

          <CaseFooterNew
            to="/projects/dreamriva/"
            title="Dream Riva"
            img="/cases/img/dreamriva/dreamriva.webp"
            full={true}
          />
        </div>
        <HelmetSite title="Жилой комплекс «Опус»" />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Opus);
